<template lang="pug">
    .popup-container(v-if="isHidden")
        .popup-wrapper(v-show="isHidden")
            a(href="" @click.prevent="toggle").popup-close
                img(src="@/assets/images/misc/popup-close.svg")

            .meal-popup-container(v-closable="{ exclude: [], handler: 'onClose' }")
                h4(ref="button") {{ singleMeal.meal_plan_name }}

                p.cost LKR {{ singleMeal.price_per_person }} each

                .description
                    div(v-html="singleMeal.description")

                //- h5 This meal includes

                //- .included-packages
                //-     ul
                //-         li Lorem ipsum dolor
                //-         li Lorem ipsum dolor
                //-         li Lorem ipsum dolor
                //-         li Lorem ipsum dolor
                //-         li Lorem ipsum dolor
                //-         li Lorem ipsum dolor
                //-         li Lorem ipsum dolor
                //-         li Lorem ipsum dolor

                //- a(href="").button Proceed with booking
</template>

<script>
    export default {
        name: 'MealPopup',
        data() {
            return {
                isHidden: false
            }
        },
        props: ['singleMeal'],
        methods: {            
            toggle: function() {
                this.isHidden = !this.isHidden
            },
            onClose: function() {
                this.isHidden = false;
            }            
        }
    }
</script>

<style lang="sass">
    @import "@/assets/css/2-base/_variables.sass"
    @import "@/assets/css/2-base/_placeholder.sass"
    @import "@/assets/css/3-components/_popup-slider.sass"    
</style>


